/// <reference path="../../../../../../typings/globals/angular-route/index.d.ts" />
/// <reference path="../../../../../../typings/globals/angular/index.d.ts" />
/// <reference path="../../../../../../typings/globals/jquery/index.d.ts" />
/// <reference path="../../../../../../typings/globals/lodash/index.d.ts" />
/// <reference path="../../ekh/services/brandedFareTypes.service.ts" />

'use strict';

namespace Core {

    class BrandedFare {
        onSelect: (any) => void;
        fare: ekh.IBrandedFareType;
        classNameIn: string;
        classNameOut: string;
        selectButtonLabel: string;
        selectedButtonLabel: string;
        selectedFareTotalPrice: number;
        currency: string;
        pieceConceptLegIn: boolean;
        pieceConceptLegOut: boolean;
        fs: any = sessionStorage.getItem('storeSelectedFlight');
        qtys: any = sessionStorage.getItem('priceQtys');
        collected: boolean = false;
        guid: any = this.guidService.uuid();
        hts: any = sessionStorage.getItem('hotelDetailsSkywards');
        skywardsPoints: number = 0;
        flightMilesToPkgPP: number = 0;
        code: string = TRPCONFIG.Domain.CultureCode;
        constructor (
            private brandedFareTypesService: ekh.BrandedFareTypesService,
            private resourceService: Core.ResourceService,
            private $filter: ng.IFilterService,
            private basketStore: any,
            private guidService: Core.GuidService,
            private tripService: any,
            private $routeParams: ng.route.IRouteParamsService,
            private hotelSearch: any,
        ) {

        }

        $onInit() {
            this.getPackage(this.fare);
            this.classNameIn = this.brandedFareTypesService._setClassName(this.fare.FlightSectors[0].TransformedType);
            this.classNameOut = this.brandedFareTypesService._setClassName(this.fare.FlightSectors[1].TransformedType);
            this.selectButtonLabel = this.resourceService.get('BRANDED_FARE_TYPES_BUTTON_SELECT');
            this.selectedButtonLabel = this.resourceService.get('BRANDED_FARE_TYPES_BUTTON_SELECTED');
        }

        public select() {
            TRPCONFIG.Domain.totalHolidayPrice = undefined;
            this.onSelect(this.fare);

            let oldPrice = TRPCONFIG.Domain.FlightFare.BrandedFareTypeTotalPrice;
            let t = this;

            let intvl = setInterval(function(){
                if (oldPrice !== TRPCONFIG.Domain.FlightFare.BrandedFareTypeTotalPrice) {
                    clearInterval(intvl);
                    t.getCancellationDetails();
                }
            }, 100);
        }

        public async getCancellationDetails() {
            let cancellation = await this.brandedFareTypesService.getCancellationCharges(TRPCONFIG.BasketId);
            TRPCONFIG.Domain.BrandedFareCancellations = cancellation;
            return cancellation;
        }

        public getBaggage(sector: ekh.IFlightSector) {
            return sector.BaggageText;
        }

        public getCabinBaggage(sector: ekh.IFlightSector) {
            return sector.CabinBaggageText;
        }

        public getSeatsSelection(sector: ekh.IFlightSector) {
            return sector.SeatsSelectionText;
        }

        public getChauffeur(sector: ekh.IFlightSector) {
            return sector.ChauffeurText;
        }

        public getCancellations(sector: ekh.IFlightSector) {
            let charge = sector.BrandedFareCancellationCharge.Amount;
            let date = sector.BrandedFareCancellationDate;
            let formatedDate = this._cancellationDateFormat(date);
            return `${this.$filter<any>('roundedCurrency')(charge)} after ${formatedDate}`;
        }

        public displaySkywards(sector: ekh.IBrandedFareType) {
            return this.skywardsPoints;
        }
        public displayTotalPkgFlightMiles(sector: ekh.IBrandedFareType) {
            TRPCONFIG.Domain.SkywardsFlightMiles = this.flightMilesToPkgPP;
            return this.flightMilesToPkgPP;
        }
        public async getPackage(fare) {
            let trip = await this.tripService.getTrip(this.$routeParams.tripId).then(t => {
                return t;
            });
            let selectedFlight = JSON.parse(sessionStorage.getItem('storeSelectedFlight') || '{}');
            let legs = fare.Legs || selectedFlight.Legs;
            let hotel = JSON.parse(sessionStorage.getItem('hotelData') || '{}');

            let baseCost = Number(sessionStorage.getItem('baseCost')) || this.basketStore.baseCostTotal();
            let qtys = JSON.parse(this.qtys);

            let totalFares = this.brandedFareTypesService.calculateTotalFares(fare, qtys);
            let totalTaxes = this.brandedFareTypesService.calculateTotalTaxes(fare, qtys);
            let fareEachPerson=fare.AdultFare.Amount;
            let packageCost = baseCost + totalFares + TRPCONFIG.Domain.TransferPrice;
            if (packageCost) {
                let accruedMiles =
                    await this.brandedFareTypesService.payloadEntry(null, trip, legs, hotel, packageCost);
                if (accruedMiles[0] && accruedMiles[0].Miles) {
                    this.skywardsPoints = await accruedMiles[0].Miles;
                }
            }
            let origin = this.brandedFareTypesService.getDepartureCode(legs);
            let destination = this.brandedFareTypesService.getDestinationCode(legs);

            let fareAndFlightSelectors = fare && fare.FlightSectors;
            let fareAndFlightAndBrandtitles =
                fareAndFlightSelectors &&
                fare.FlightSectors[0].BrandTitle === fare.FlightSectors[1].BrandTitle;

            let miles = this.brandedFareTypesService.getFareInfo
                (fareAndFlightSelectors, fareAndFlightAndBrandtitles, this.brandedFareTypesService.flightMilesToPkgPP,
                    fare, this.hotelSearch, origin, destination, null, null);

            this.flightMilesToPkgPP = await miles;
            return await miles;
        }
        public getPriceDelta(): string {
            const dif = this.fare.BrandedFareTypeTotalPrice - this.selectedFareTotalPrice;
            if (Math.round(dif) === 0) {
                return '';
            }
            let sign = dif > 0 ? '+' : '';
            return `${sign}${this.$filter<any>('roundedCurrency')(dif, this.currency)}`;
        }

        public isRestrictedSeats(sector: ekh.IFlightSector) {
            return this.brandedFareTypesService.isRestrictedSeats(sector);
        }

        public getSeatsSelectionTooltipText() {
            return this.resourceService.get('BRANDED_FARE_TYPES_SEAT_RESTRICTED_TOOLTIP_TEXT');
        }

        public isSameClass(tripBound, flight) {
            if (flight.Segments.length > 1) {
                let fs = flight.Segments;
                if (fs) {
                    const fareClassArr = fs.map(x => {
                        if (x.FareClass) {
                            return x.FareClass;
                        } else {
                            return x.SupplierFareClass;
                        }
                    });
                    const allEqual = arr => arr.every(val => val !== undefined && val === arr[0]);
                    const result = allEqual(fareClassArr);
                    return result;
                }

            }

            return true;
        }


        public titleHeader(fs, dir, bound, flight) {
            let brandTitle = flight.BrandTitle;
            if(brandTitle.match(/flex/i)) {
                let splitText = brandTitle.split('Flex');
                brandTitle = `<strong>${splitText[0]}</strong><br /> Flex ${splitText[1]}`;
            } else if(brandTitle.match(/saver/i)) {
                let splitText = brandTitle.split('Saver');
                brandTitle = `<strong>${splitText[0]}</strong><br /> Saver ${splitText[1]}`;
            }else if(brandTitle.match(/special/i)) {
                let splitText = brandTitle.split('Special');
                brandTitle = `<strong>${splitText[0]}</strong><br /> Special ${splitText[1]}`;
            }

            let classCheck = this.isSameClass(bound, flight);
            let toolTipText = '';
            let codes = [];
            if (!classCheck) {

                if (fs) {
                    let fsParse = JSON.parse(fs);
                    let legs = bound === 'outbound' ? fsParse.Legs[0] : fsParse.Legs[1];

                    codes = legs.Segments.map(x => {
                        return `${x.DepartureAirportCode} - ${x.DestinationAirportCode}`;
                    });
                }

                let segments: any = [];

                for(let i = 0; i < flight.Segments.length; i++) {
                    let fc = flight.Segments[i].FareClass;
                    if(!fc) {
                        fc = flight.Segments[i].SupplierFareClass;
                    }

                    let s = `<strong>${codes[i]}</strong>: ${this.brandedFareTypesService.getClassName(fc)} Class`;
                    segments.push(s);
                }

                let segmentText = segments.join('<br>');

                toolTipText = `<div class="stop-tooltip-box">
                                    <p><strong>${flight.BrandTitle} Class is partially available</strong><p>
                                    <p>${flight.BrandTitle} Class is not avaliable on all sectors of your journey
                                    <br>${segmentText}</p>
                                </div>
                                <span class="stop-tooltip">
                                    <img src="/build/img/emiratesHolidays/brandedFareTypes/ic-info-white.svg"/>
                                    Partially Available
                                </span>`;
            }

            return `<img src="/build/img/emiratesHolidays/brandedFareTypes/ic-plane-${dir}-white.svg">
                    <span>${brandTitle}</span> ${toolTipText}`;
        }

        private getCultureCode(code) {
            let data = {
                'ar-ae': {
                    'MONTH': ['\u064a\u0646\u0627\u064a\u0631', '\u0641\u0628\u0631\u0627\u064a\u0631',
                    '\u0645\u0627\u0631\u0633', '\u0623\u0628\u0631\u064a\u0644', '\u0645\u0627\u064a\u0648',
                    '\u064a\u0648\u0646\u064a\u0648', '\u064a\u0648\u0644\u064a\u0648',
                    '\u0623\u063a\u0633\u0637\u0633', '\u0633\u0628\u062a\u0645\u0628\u0631',
                    '\u0623\u0643\u062a\u0648\u0628\u0631', '\u0646\u0648\u0641\u0645\u0628\u0631',
                    '\u062f\u064a\u0633\u0645\u0628\u0631'],
                },
                'de-de': {
                    'MONTH': ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
                    'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
                },
                'dk-da': {
                    'MONTH': ['Januar', 'Februar', 'Marts', 'April', 'Maj', 'Juni',
                    'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
                },
                'en-gb': {
                    'MONTH': ['January', 'February', 'March', 'April', 'May', 'June',
                    'July', 'August', 'September', 'October', 'November', 'December']
                },
                'it-it': {
                    'MONTH': ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
                    'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
                },
                'ru-ru': {
                    'MONTH': ['\u044f\u043d\u0432\u0430\u0440\u044f', '\u0444\u0435\u0432\u0440\u0430\u043b\u044f',
                    '\u043c\u0430\u0440\u0442\u0430', '\u0430\u043f\u0440\u0435\u043b\u044f', '\u043c\u0430\u044f',
                    '\u0438\u044e\u043d\u044f', '\u0438\u044e\u043b\u044f',
                    '\u0430\u0432\u0433\u0443\u0441\u0442\u0430',
                    '\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044f',
                    '\u043e\u043a\u0442\u044f\u0431\u0440\u044f',
                    '\u043d\u043e\u044f\u0431\u0440\u044f',
                    '\u0434\u0435\u043a\u0430\u0431\u0440\u044f'],
                },
                'sv-se': {
                    'MONTH': ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni',
                    'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
                }
            };

            let months = data['en-gb'].MONTH;

            let d = Object.keys(data);
            for (let i = 0; i < d.length; i++) {
                if (code === d[i]) {
                    months = data[d[i]].MONTH;
                }
            }

            return months;
        }

        private _monthFormat(month) {
            let months = this.getCultureCode(this.code);
            return months[month];
        }

        private _cancellationDateFormat(date) {
            let timestamp = Date.parse(date);
            let d = new Date (timestamp);
            let month = this._monthFormat(d.getMonth());
            return `${d.getDate()} ${month} ${d.getFullYear()}`;

        }

    }

    angular
        .module('core')
        .directive('brandedFare', (): ng.IDirective => {
            return {
                restrict: 'E',
                controller: BrandedFare,
                controllerAs: 'bf',
                bindToController: {
                    isSelected: '=',
                    fare: '=',
                    onSelect: '&',
                    pieceConceptLegIn: '=',
                    pieceConceptLegOut: '=',
                    selectedFareTotalPrice: '=',
                    currency: '='
                },
                templateUrl: 'partials/home/directivetemplate?type=BrandedFares'
            };
        });
}
